// Mock data for Jolly Tots Rides website

export const navigationLinks = [
  { name: 'Home', href: '/' },
  { name: 'How It Works', href: '/how-it-works' },
  { name: 'Safety First', href: '/safety' },
  { name: 'For Malls & Partners', href: '/partners' },
];

export const heroData = {
  headline: 'Safer. Happier. Stress-Free Shopping for Families.',
  subheadline: 'Car-shaped ride-on shopping trolleys designed for children aged 1–6 — giving parents peace of mind while kids enjoy the ride.',
  primaryCta: { text: 'For Parents', href: '/parents' },
  secondaryCta: { text: 'For Malls & Partners', href: '/partners' },
};

export const benefits = [
  {
    id: 1,
    icon: 'car',
    title: 'Child-Friendly Design',
    description: 'Car-shaped trolleys that kids love, making shopping an adventure rather than a chore.',
  },
  {
    id: 2,
    icon: 'shield',
    title: 'Safety First',
    description: 'Secure harnesses, trained attendants, and sanitised equipment for your peace of mind.',
  },
  {
    id: 3,
    icon: 'heart',
    title: 'Parent Peace of Mind',
    description: 'Shop stress-free knowing your child is safe, entertained, and visible at all times.',
  },
];

export const howItWorksSteps = [
  {
    id: 1,
    step: '1',
    title: 'Pick Up at the Jolly Bay',
    description: 'Locate our branded Jolly Bay station at participating malls and check in with our friendly attendant.',
  },
  {
    id: 2,
    step: '2',
    title: 'Secure Your Child',
    description: 'Our trained staff will help secure your child safely with our 5-point harness system.',
  },
  {
    id: 3,
    step: '3',
    title: 'Shop with Confidence',
    description: 'Enjoy your shopping while your little one has fun riding in their very own car trolley.',
  },
  {
    id: 4,
    step: '4',
    title: 'Easy Return & Sanitisation',
    description: 'Return to any Jolly Bay. We sanitise every trolley after each use for the next family.',
  },
];

export const safetyFeatures = [
  {
    id: 1,
    icon: 'seatbelt',
    title: 'Child Safety Seatbelt & Harness',
    description: 'Every ride includes a secure 5-point harness to keep your child safely seated throughout your shopping trip.',
  },
  {
    id: 2,
    icon: 'weight',
    title: 'Max Weight: 30kg',
    description: 'Designed to safely accommodate children up to 30kg, ensuring stability and comfort.',
  },
  {
    id: 3,
    icon: 'users',
    title: 'Trained Jolly Attendants',
    description: 'Our friendly staff are trained in child safety procedures and equipment operation.',
  },
];

export const futureFeature = {
  title: 'Tracking Technology – Coming soon',
  description: 'GPS-enabled trolleys with real-time location alerts for added peace of mind.',
};

export const busyDaysFeatures = [
  { id: 1, text: 'Additional trolleys during peak times.' },
  { id: 2, text: 'Extra attendants to assist families.' },
  { id: 3, text: 'QR-based booking options available.' },
];

export const pricingPlans = [
  { duration: '1 hour', price: 'R100' },
  { duration: '2 hours', price: 'R150' },
  { duration: '3 hours', price: 'R200' },
  { duration: '4 hours', price: 'R250' },
  { duration: 'Extra hour', price: 'R50' },
];

export const faqItems = [
  {
    id: 1,
    question: 'What ages are the trolleys designed for?',
    answer: 'Our car-shaped trolleys are designed for children aged 1 to 6 years, with a maximum weight capacity of 30kg.',
  },
  {
    id: 2,
    question: 'How do I book a trolley?',
    answer: 'Simply visit any Jolly Bay station at participating malls. Walk-ins are welcome, and online booking will be available soon.',
  },
  {
    id: 3,
    question: 'Are the trolleys sanitised?',
    answer: 'Yes! Every trolley is thoroughly sanitised after each use to ensure the highest hygiene standards.',
  },
  {
    id: 4,
    question: 'What if my child exceeds the weight limit?',
    answer: 'For safety reasons, we cannot accommodate children exceeding 30kg. Our attendants will verify this during check-in.',
  },
  {
    id: 5,
    question: 'Can I extend my rental time?',
    answer: 'Yes! Simply return to the Jolly Bay and speak with our attendant to extend your rental at R50 per additional hour.',
  },
];

export const mallBenefits = [
  { id: 1, icon: 'clock', text: 'Increased dwell time', description: 'Families shop longer when children are entertained.' },
  { id: 2, icon: 'smile', text: 'Improved customer experience', description: 'Happy families mean positive mall associations.' },
  { id: 3, icon: 'building', text: 'Family-friendly brand positioning', description: 'Position your mall as the go-to destination for families.' },
  { id: 4, icon: 'trophy', text: 'Competitive differentiation', description: 'Stand out from competing malls with unique family services.' },
  { id: 5, icon: 'trending-up', text: 'Additional revenue opportunities', description: 'Partnership model with minimal capital investment.' },
  { id: 6, icon: 'star', text: 'Greater customer loyalty', description: 'Create memorable experiences that bring families back.' },
];

export const operationalExcellence = [
  { id: 1, text: 'Trained on-site attendants' },
  { id: 2, text: 'Structured check-in/check-out' },
  { id: 3, text: 'Asset tracking and maintenance' },
  { id: 4, text: 'Risk mitigation procedures' },
];

export const partnerLocations = [
  { name: 'Malls in South Africa', logo: 'south-africa' },
];

export const galleryImages = [
  { id: 1, title: 'Car-shaped Trolleys', category: 'trolleys' },
  { id: 2, title: 'Branded Jolly Bays', category: 'stations' },
  { id: 3, title: 'Road-themed Decor', category: 'decor' },
  { id: 4, title: 'Photo Booth Moments', category: 'memories' },
  { id: 5, title: 'Seasonal Events', category: 'events' },
  { id: 6, title: 'Happy Families', category: 'families' },
];

export const contactInfo = {
  email: 'hello@jollytotsrides.co.za',
  phone: '+27 83 413 2691',
  address: 'Cape Town, South Africa',
};

export const footerLinks = {
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'How It Works', href: '/how-it-works' },
    { name: 'Safety First', href: '/safety' },
    { name: 'Gallery', href: '/gallery' },
  ],
  services: [
    { name: 'For Parents', href: '/parents' },
    { name: 'For Malls & Partners', href: '/partners' },
    { name: 'Pricing', href: '/parents#pricing' },
    { name: 'Find a Location', href: '/locations' },
  ],
  legal: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Safety Guidelines', href: '/safety' },
  ],
};
